<template>
    <section>
        <div class="cbp-form">
            <h3>Aircraft Information</h3>

            <div class="mb-3">
                <label>Landing Date and Time: <span class="required">*</span> <small>(Additional fees apply if landing time is outside of facility hours: Thursday-Monday 10am-6pm)</small></label>
                <VueDatePicker v-model="store.arrivalDate" :enable-time-picker="true" auto-apply model-type="format" format="MM/dd/yyyy HH:mm" :class="{ 'is-invalid': v$.arrivalDate.$errors.length > 0 }"></VueDatePicker>
                <div v-for="error of v$.arrivalDate.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
            </div>

            <div class="form-floating mb-3">

                <select v-model="store.dataSetId" class="form-select" id="floatingCountry" :class="{ 'is-invalid': v$.dataSetId.$errors.length > 0 }">
                    <option v-for="dataSet in store.dataSets" :value="dataSet.id">{{ dataSet.country }} - {{ dataSet.countryName }}</option>
                    <option value="-1">Other</option>
                </select>
                <label for="floatingCountry">Country Aircraft is Registered: <span class="required">*</span></label>
                <div v-for="error of v$.dataSetId.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
            </div>

            <div class="mb-3">
                <template v-if="store.dataSetId > 0">
                    <div class="input-group">
                        <span class="input-group-text">
                            {{ selectedDataSet.prefix }}
                        </span>
                        <div class="form-floating">
                            <input type="text" class="form-control" id="floatingTailNumber" v-model="store.aircraftTailNumber" @blur="lookupAircraft" :class="{ 'is-invalid': v$.aircraftTailNumber.$errors.length > 0 }" />
                            <label for="floatingTailNumber">Registration (Tail Number): <span class="required">*</span></label>
                            <div v-for="error of v$.aircraftTailNumber.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="form-floating">
                        <input type="text" class="form-control" id="floatingTailNumber" v-model="store.aircraftTailNumber" :class="{ 'is-invalid': v$.aircraftTailNumber.$errors.length > 0 }" />
                        <label for="floatingTailNumber">Registration (Tail Number): <span class="required">*</span></label>
                        <div v-for="error of v$.aircraftTailNumber.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
                    </div>
                </template>
            </div>

            <div class="mb-3 form-floating">
                <input type="text" class="form-control" id="floatingYear" placeholder="" v-model="store.aircraftYear" />
                <label for="floatingYear">Year:</label>
            </div>

            <div class="mb-3 form-floating">
                <input type="text" class="form-control" id="floatingMake" placeholder="" v-model="store.aircraftMake" />
                <label for="floatingMake">Make:</label>
            </div>

            <div class="mb-3 form-floating">
                <input type="text" class="form-control" id="floatingModel" placeholder="" v-model="store.aircraftModel" />
                <label for="floatingModel">Model:</label>
            </div>

            <div class="mb-3 form-floating">
                <select v-model="store.aircraftEngines" class="form-select" id="floatingEngines">
                    <option value="1">Single-engine</option>
                    <option value="2">Multi-engine</option>
                </select>
                <label for="floatingEngines">Engines:</label>
            </div>

            <div class="mb-3 form-floating">
                <select v-model="store.engineType" class="form-select" id="floatingEngineType">
                    <option value="P">Prop (Piston, Turbo Prop, Turbo Shaft, etc.)</option>
                    <option value="J">Jet (Turbo Fan, Turbo Jet, Ramjet, etc.)</option>
                </select>
                <label for="floatingEngineType">Engine Type:</label>
            </div>

            <div class="mb-3 form-floating">
                <input type="text" class="form-control" id="floatingMaxLandingWeight" v-model="store.aircraftMaxLandingWeight" :class="{ 'is-invalid': v$.aircraftMaxLandingWeight.$errors.length > 0 }" />
                <label for="aircraftMaxLandingWeight">Maximum Landing Weight (in pounds): <span class="required">*</span></label>
                <div v-for="error of v$.aircraftMaxLandingWeight.$errors" :key="error.$uid" class="error">{{ error.$message }}</div>
            </div>


            <div class="text-center">
                <button type="button" class="btn btn-primary" @click="goToPage('PAYMENT')">Next</button>
            </div>
        </div>
    </section>
</template>

<script setup>
    import { computed } from 'vue';
    import VueDatePicker from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css';
    import { useStore } from './store';
    import useVuelidate from '@vuelidate/core';
    import { required, helpers } from '@vuelidate/validators';

    const store = useStore();

    const emit = defineEmits(['goToPage']);

    const greaterThanZero = (value) => Number(value) > 0;

    const rules = computed(() => ({
        arrivalDate: { required },
        dataSetId: { required },
        aircraftTailNumber: { required },
        aircraftMaxLandingWeight: { required, greaterThanZero: helpers.withMessage('Value must be greater than 0', greaterThanZero) }
        //aircraftEngines: { required },
        //engineType: { required }
    }));

    const v$ = useVuelidate(rules, store);

    const selectedDataSet = computed(() => {
        return store.dataSets.find(ds => ds.id == store.dataSetId);
    });

    async function goToPage(page) {
        var isValid = await v$.value.$validate();

        if (isValid)
            emit('goToPage', page);
    }

    function lookupAircraft() {

        $.ajax({
            url: store.aircraftLookupUrl + '/' + store.aircraftTailNumber + '?dataSetId=' + store.dataSetId,
            method: "GET",
            success: function (response) {
                store.aircraftYear = response.year;
                store.aircraftMake = response.make;
                store.aircraftModel = response.model;

                var engines = parseInt(response.engines);
                if (engines == 1) {
                    store.aircraftEngines = 1;
                }
                else {
                    store.aircraftEngines = 2;
                }

                if (response.engineType == 1 || response.engineType == 2 || response.engineType == 3 || response.engineType == 8) {
                    store.engineType = "P";
                }
                else if (response.engineType == 4 || response.engineType == 5) {
                    store.engineType = "J";
                }

                store.aircraftMaxLandingWeight = response.maxLandedWeight;
            }
        });
    }
</script>